var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgJm = function SvgJm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l320 240L0 480zM640 0L320 240l320 240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l320 240L640 0zM0 480l320-240 320 240z",
    fill: "#090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 0h-59.625L0 435.281V480h59.629L640.004 44.719z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v44.722l580.375 435.28h59.629v-44.72L59.629 0z",
    fill: "#fc0"
  }))));
};
export default __webpack_public_path__ + "assets/755951cf4799d86cc8b674ff9f226531.svg";
export { SvgJm as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/jm.svg